import { useRecord } from "./useRecord";

export function useUserContactInfo(userId?: string | null) {
  return useRecord("user_contact_info", userId, { name: "useUserContactInfo" });
}
